import * as React from 'react';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export class Flex extends React.PureComponent<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> {
    render() {
        const { style, ...props } = this.props;
        return <div style={{ display: 'flex', ...style }} {...props} />;
    }
}
